export default __webpack_public_path__ + "static/media/verifyIDoff.1975cd2f.svg";